module.exports = __webpack_public_path__ + "img/actslogo.80073854.png";